/**
 * Custom content stack
 * Deferred video loading for the Video block.
 *
 * The markup ships a poster button plus a <template> holding the real player.
 * Nothing loads until someone clicks, so YouTube and Vimeo embeds stay off the
 * page on first paint.
 */

if (!customElements.get('ccs-video')) {
  customElements.define(
    'ccs-video',
    class CcsVideo extends HTMLElement {
      constructor() {
        super();

        this.poster = this.querySelector('[data-ccs-poster]');
        if (!this.poster) return;

        this.poster.addEventListener('click', this.loadMedia.bind(this), { once: true });
      }

      loadMedia() {
        const template = this.querySelector('template');
        if (!template) return;

        const media = template.content.firstElementChild;
        if (!media) return;

        const node = media.cloneNode(true);

        this.appendChild(node);
        this.setAttribute('data-loaded', 'true');

        if (this.poster) this.poster.remove();
        template.remove();

        const player = this.querySelector('video, iframe');
        if (!player) return;

        player.focus({ preventScroll: true });

        if (typeof player.play === 'function') {
          const attempt = player.play();
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => {
              /* Browser blocked unmuted autoplay. Controls are visible, so leave it. */
            });
          }
        }
      }
    }
  );
}
